

















import { Component, Prop, Vue } from 'vue-property-decorator';
import LocaleText from "../../components/LocaleText.vue";

export enum HotspotBubbleOrientation { left = "left", right = "right", up = "up", upleft = "upleft" }

@Component({
    components: {LocaleText},
    data() { return {

    }},
    computed: {
        iconClass():string {
            return this.$props.icon;
        },
        orientationClass():string {
            return this.$props.orientation;
        }
    },
    methods: {
        handleClick():void {
            this.$emit('click');
        }
    }
})
export default class HotspotBubble extends Vue {
    @Prop() private orientation!: string;
    @Prop() private icon!: string;
    @Prop() private enabled!: boolean;
    @Prop() private localeTag!: string;
    @Prop() private click!: any;
}
